import React, { useEffect, useState, useRef } from "react";

import {
  SearchOutlined,
  EditOutlined,
  ReloadOutlined,
  CheckOutlined,
  CloseOutlined,
  FileImageOutlined,
} from "@ant-design/icons";
import {
  PageHeader,
  Pagination,
  Input,
  Button,
  Table,
  Spin,
  Typography,
  Tag,
  message,
  InputNumber,
  Switch,
  Tooltip,
  Popconfirm,
} from "antd";

import moment from "moment";

import ProductsTable from "../../components/products/ProductsTable";
import ImageChecker from "../../components/Generic/ImageChecker";

import ProductsAddEditModal from "../../components/products/ProductsAddEditModal";
import ProductCards from "../../components/products/ProductCards";
import PrintProductBarCode from "../../components/products/PrintProductBarCode";
import RecalculateProductPrice from "../../components/products/RecalculateProductPrice";
import PackageAddtoCartButton from "../../components/packages/PackageAddtoCartButton";
import ProductLogModal from "../../components/analytics/ProductLogModal";

import SalesExportSpecificProduct from "../../components/analyticsTabs/exports/salesExportSpecificProduct";

import { useDispatch, useSelector, shallowEqual } from "react-redux";
import {
  loadMoreProductData,
  onChangeIncomingcount,
  onAcceptIncomingcount,
} from "../../Redux/actions/productActions";
import { getLocations } from "../../Redux/actions/locationsActions";
import {
  addCartItem,
  getCart,
  editCartItem,
} from "../../Redux/actions/cartActions";
import { getOptions } from "../../Redux/actions/crudActions";
import { numberWithCommas } from "../../utils/helpers";

import ProductQuickStats from "../../components/analytics/ProductQuickStats";

import "./styles.scss";
import "./styles.css";
import { set } from "gl-vec2";
import ReactToPrint from "react-to-print";

const { Search } = Input;
const INITIAL_STATE = {
  searchText: "",
};
const API_URL = "products";

const PAGENAME = "Product";

const MODAL_BLUEPRINT = [
  {
    title: "Name",
    key: "name",
    type: "text",
  },
  {
    title: "category",
    key: "category",
    type: "options",
    api: "product_categories",
  },
  {
    title: "category_name",
    key: "category_name",
    type: "hidden",
  },
  {
    title: "brand",
    key: "brand",
    type: "options-multiple",
    api: "brands",
  },
  {
    title: "brand_name",
    key: "brand_name",
    type: "hidden",
  },
  {
    title: "SKU",
    key: "sku",
    type: "text",
  },
  {
    title: "Supplier Code",
    key: "supplier_code",
    type: "text",
  },

  {
    title: "Unit",
    key: "unit",
    type: "text",
  },

  {
    title: "Regionalization",
    key: "regionalization",
    type: "fixed-options",
    choices: [
      { value: "local", label: "Local" },
      { value: "international", label: "International" },
    ],
  },
  {
    title: "regionalization_name",
    key: "regionalization_name",
    type: "hidden",
  },
  {
    title: "Supplier",
    key: "supplier",
    type: "text",
  },
  {
    title: "description",
    key: "description",
    type: "text-area",
  },
];

const WAREHOUSE_MODAL_BLUEPRINT = [
  {
    title: "Name",
    key: "name",
    type: "text",
  },
  {
    title: "category",
    key: "category",
    type: "options",
    api: "product_categories",
  },
  {
    title: "category_name",
    key: "category_name",
    type: "hidden",
  },
  {
    title: "brand",
    key: "options-multiple",
    type: "options",
    api: "brands",
  },
  {
    title: "brand_name",
    key: "brand_name",
    type: "hidden",
  },
  {
    title: "SKU",
    key: "sku",
    type: "text",
  },
  {
    title: "Supplier Code",
    key: "supplier_code",
    type: "text",
  },

  {
    title: "Unit",
    key: "unit",
    type: "text",
  },
  {
    title: "Secondary Unit Conversion Rate",
    key: "second_unit_rate",
    type: "number",
  },
  {
    title: "Secondary Unit",
    key: "second_unit",
    type: "text",
  },
  {
    title: "Regionalization",
    key: "regionalization",
    type: "fixed-value",
    value: "local",
  },
  {
    title: "regionalization_name",
    key: "regionalization_name",
    type: "fixed-value",
    value: "Local",
  },
  {
    title: "Supplier",
    key: "supplier",
    type: "text",
  },
  {
    title: "description",
    key: "description",
    type: "text-area",
  },
  {
    title: "HQ Only",
    key: "hq_only",
    type: "boolean",
  },
  {
    title: "Menu Item",
    key: "menu_item",
    type: "boolean",
  },
  {
    title: "Require Scan",
    key: "need_scan",
    type: "boolean",
  },
  {
    title: "Item expires",
    key: "expires",
    type: "boolean",
  },

  {
    title: "Shelf Life ",
    key: "shelf_life",
    type: "number",
    suffix: "month/s",
  },
];

const INTERNATIONAL_MODAL_BLUEPRINT = [
  {
    title: "Name",
    key: "name",
    type: "text",
  },
  {
    title: "category",
    key: "category",
    type: "options",
    api: "product_categories",
  },
  {
    title: "category_name",
    key: "category_name",
    type: "hidden",
  },
  {
    title: "brand",
    key: "brand",
    type: "options-multiple",
    api: "brands",
  },
  {
    title: "brand_name",
    key: "brand_name",
    type: "hidden",
  },
  {
    title: "SKU",
    key: "sku",
    type: "text",
  },

  {
    title: "Unit",
    key: "unit",
    type: "text",
  },
  {
    title: "Secondary Unit",
    key: "second_unit",
    type: "text",
  },

  {
    title: "description",
    key: "description",
    type: "text-area",
  },
];

const ADMIN_MODAL_BLUEPRINT = [
  {
    title: "Name",
    key: "name",
    type: "text",
  },

  {
    title: "category",
    key: "category",
    type: "options",
    api: "product_categories",
  },
  {
    title: "category_name",
    key: "category_name",
    type: "hidden",
  },
  {
    title: "brand",
    key: "brand",
    type: "options-multiple",
    api: "brands",
  },
  {
    title: "brand_name",
    key: "brand_name",
    type: "hidden",
  },
  {
    title: "SKU",
    key: "sku",
    type: "text",
  },
  {
    title: "Supplier Code",
    key: "supplier_code",
    type: "text",
  },

  {
    title: "Unit",
    key: "unit",
    type: "text",
  },
  {
    title: "Secondary Unit",
    key: "second_unit",
    type: "text",
  },
  {
    title: "Secondary Unit Conversion Rate",
    key: "second_unit_rate",
    type: "number",
  },
  {
    title: "Regionalization",
    key: "regionalization",
    type: "fixed-options",
    choices: [
      { value: "local", label: "Local" },
      { value: "international", label: "International" },
    ],
  },
  {
    title: "regionalization_name",
    key: "regionalization_name",
    type: "hidden",
  },
  {
    title: "Supplier",
    key: "supplier",
    type: "text",
  },
  {
    title: "description",
    key: "description",
    type: "text-area",
  },
  {
    title: "HQ Only",
    key: "hq_only",
    type: "boolean",
  },
  {
    title: "Menu Item",
    key: "menu_item",
    type: "boolean",
  },
  {
    title: "Require Scan",
    key: "need_scan",
    type: "boolean",
  },
  {
    title: "Item expires",
    key: "expires",
    type: "boolean",
  },

  {
    title: "Shelf Life ",
    key: "shelf_life",
    type: "number",
    suffix: "month/s",
  },
  {
    title: "is wastable",
    key: "is_wastable",
    type: "boolean",
  },
  {
    title: "is premix",
    key: "is_premix",
    type: "boolean",
  },
  {
    title: "is resell",
    key: "is_resell",
    type: "boolean",
  },
  {
    title: "dont audit",
    key: "excludeFromAudit",
    type: "boolean",
  },
  {
    title: "Franchise Price (₱)",
    key: "franchise_price",
    type: "number",
    prefix: "₱",
  },
  {
    title: "Sell Price (₱)",
    key: "sell_price",
    type: "number",
    prefix: "₱",
  },
  {
    title: "Grab Price (₱)",
    key: "grab_price",
    type: "number",
    prefix: "₱",
  },
  {
    title: "Food Panda Price (₱)",
    key: "fp_price",
    type: "number",
    prefix: "₱",
  },
];

const Index = (props) => {
  const [loading, setloading] = useState(false);
  const [mainSearch, setMainSearch] = useState(null);
  const [resetTable, setResetTable] = useState(false);

  const [modalMode, setModalMode] = useState("edit");
  const [currentSelected, setCurrentSelected] = useState(null);

  const [categoryFilters, setCategoryFilters] = useState([]);
  const [brandFilters, setBrandFilters] = useState([]);

  const [menuItemsOnly, setMenuItemsOnly] = useState(false);
  const [hqloc, setHQloc] = useState(null);

  const tableRef = useRef();
  const dispatch = useDispatch();
  const { user, crudData, crudDataCount, locations, cart } = useSelector(
    (state) => ({
      user: state.auth.user,
      crudData: state.products.data,
      crudDataCount: state.products.dataCount,
      locations: state.locations.locations,
      cart: state.cart.data,
    }),
    shallowEqual
  );
  useEffect(() => {
    retreiveCats();
    retreiveBrands();
    dispatch(getLocations());
  }, []);

  useEffect(() => {
    if (locations) {
      locations.map((loc) => {
        if (loc.commissary) {
          setHQloc(loc.id);
        }
      });
    }
  }, [locations]);

  useEffect(() => {
    setResetTable(!resetTable);
  }, [menuItemsOnly]);

  const retreiveCats = () => {
    var requestData = {
      apiurl: "product_categories",
    };
    dispatch(getOptions(requestData)).then((documentSnapshots) => {
      var docs = documentSnapshots.docs;
      var dataArray = [];
      docs.map((item) => {
        var cval = item.data();

        var newOrder = {
          key: item.id,
          id: item.id,
          text: cval.name,
          value: cval.name,
        };

        dataArray.push(newOrder);
      });
      setCategoryFilters(dataArray);
    });
  };

  const retreiveBrands = () => {
    var requestData = {
      apiurl: "brands",
    };
    dispatch(getOptions(requestData)).then((documentSnapshots) => {
      var docs = documentSnapshots.docs;
      var dataArray = [];
      docs.map((item) => {
        var cval = item.data();

        var newOrder = {
          key: item.id,
          id: item.id,
          text: cval.name,
          value: cval.name,
        };

        dataArray.push(newOrder);
      });
      setBrandFilters(dataArray);
    });
  };
  const onSearch = (value) => {
    setMainSearch(value);
  };

  const itemSelected = (value) => {
    setModalMode("edit");
    setCurrentSelected(value);
  };

  const changeIncomingCount = (record, index, incoming) => {
    dispatch(onChangeIncomingcount(record.id, incoming));
  };

  const acceptIncoming = async (record) => {
    setloading(true);
    var newqty = await dispatch(onAcceptIncomingcount(record));
    setloading(false);
    setResetTable(!resetTable);
  };

  const columns = [
    {
      title: "Category",
      dataIndex: "category_name",
      key: "category_name",
      sorter: (a, b) => a.category_name.localeCompare(b.category_name),
      fixed: "left",

      filters: categoryFilters,
      onFilter: (value, record) => value.includes(record.category_name),
      render: (text, record, index) => {
        return <div onClick={() => itemSelected(record)}>{text}</div>;
      },
    },
    {
      title: "Brand",
      dataIndex: "brand_name",
      key: "brand_name",
      sorter: (a, b) => a.brand_name.localeCompare(b.brand_name),
      fixed: "left",

      filters: brandFilters,
      onFilter: (value, record) => {
        console.log(record?.brand_name);
        if (record?.brand_name && Array.isArray(record?.brand_name)) {
          return record.brand_name.includes(value);
        }
        return true;
      },
      render: (text, record, index) => {
        return (
          <div className="vertical" onClick={() => itemSelected(record)}>
            {text?.length > 0 &&
              text.map((t) => {
                return <span>{t}</span>;
              })}
          </div>
        );
      },
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
      fixed: "left",
      search: "name",
      render: (text, record, index) => {
        return <div onClick={() => itemSelected(record)}>{text}</div>;
      },
    },
    {
      title: "Unit",
      dataIndex: "unit",
      key: "unit",
      render: (text, record, index) => {
        return <div onClick={() => itemSelected(record)}>{text}</div>;
      },
    },
  ];

  const pricecol = [
    {
      title: "Price",
      width: "7em",
      render: (text, record, index) => {
        if (record) {
          if (record.regionalization == "local" && user.role !== "manager") {
            return (
              <div onClick={() => itemSelected(record)} className="vertical">
                <span>{`₱ ${numberWithCommas(
                  parseFloat(record.cost_peso).toFixed(2)
                )}`}</span>
                <span>
                  {record.sell_price && user.role == "admin"
                    ? `₱ ${numberWithCommas(
                        parseFloat(record.sell_price).toFixed(2)
                      )}`
                    : ""}
                </span>
              </div>
            );
          }
          if (
            record.regionalization == "international" &&
            user.role == "admin"
          ) {
            return (
              <div onClick={() => itemSelected(record)}>
                {`¥ ${numberWithCommas(
                  parseFloat(record.cost_rmb).toFixed(2)
                )}`}
              </div>
            );
          }
        }
      },
    },
  ];

  const imagecol = [
    {
      title: "Image",
      width: "5em",
      render: (text, record, index) => {
        return (
          <div onClick={() => itemSelected(record)}>
            <ImageChecker
              url={`${process.env.REACT_APP_AWS_S3}${record.id}.png`}
              success={
                <img
                  src={`${process.env.REACT_APP_AWS_S3}${record.id}.png`}
                  alt="image"
                  className={"prodimage"}
                />
              }
              fail={
                <img
                  src={`${process.env.REACT_APP_AWS_S3}logo.jpg`}
                  alt="image"
                  className={"prodimage"}
                />
              }
            />
          </div>
        );
      },
    },
  ];

  const exportSalesCol = [
    {
      title: "Export Sales",
      width: "5em",
      render: (text, record, index) => {
        return (
          <div onClick={(e) => e.preventDefault()}>
            <SalesExportSpecificProduct
              product={record.id}
              productName={record.name}
            ></SalesExportSpecificProduct>
          </div>
        );
      },
    },
  ];
  const menuItemsColumns = () => {
    var newcols = columns;

    if ((user.role == "admin") | (user.role == "manager")) {
      newcols = newcols.concat(pricecol);
    }

    newcols = newcols.concat(imagecol);

    if (user.role == "admin") {
      newcols = newcols.concat(exportSalesCol);
    }

    return newcols;
  };

  const changeCartCount = (id, qty) => {
    var newdata = {
      quantity: qty,
    };

    dispatch(editCartItem(newdata, id));
    dispatch(getCart());
    message.success("cart edited");
    setloading(false);
  };

  const cartAdd = (record, qty) => {
    var cartid = `${record.id}_${user.id}`;
    var cartchecker = false;
    setloading(true);
    cart.map((item) => {
      if (cartid == item.id) {
        cartchecker = true;
        changeCartCount(item.id, qty);
      }
    });
    if (cartchecker) {
    } else {
      var newdata = {
        product: record.id,
        product_name: record.name,
        unit: record.unit,
        quantity: qty,
      };

      if (record?.direct_ship) {
        newdata.direct_ship = record.direct_ship;
      }

      dispatch(addCartItem(newdata))
        .then((res) => {
          dispatch(getCart());
          message.success("item added to cart");

          setloading(false);
        })
        .catch((err) => {
          setloading(false);
        });
    }
  };

  const filterColumns = () => {
    var newcols = columns;

    newcols = newcols.concat(pricecol);
    newcols = newcols.concat(imagecol);
    var userlocation = user.branch;
    var regioncol = [
      {
        title: "Regionalization",
        dataIndex: "regionalization",
        key: "regionalization",
        filters: [
          {
            text: "International",
            value: "international",
          },
          {
            text: "Local",
            value: "local",
          },
        ],
        onFilter: (value, record) => value.includes(record.regionalization),
        render: (text, record, index) => {
          if (record.regionalization == "international") {
            return (
              <Tag color="red" onClick={() => itemSelected(record)}>
                International
              </Tag>
            );
          } else {
            return (
              <Tag color="cyan" onClick={() => itemSelected(record)}>
                Local
              </Tag>
            );
          }
        },
      },
    ];
    if (
      user.role == "admin" ||
      user.role == "warehouse" ||
      user.role == "manager"
    ) {
      newcols = newcols.concat(regioncol);
    }

    var quickstatscol = [
      {
        title: "Quick Stats",

        render: (text, record, index) => {
          return (
            <ProductQuickStats
              branchID={user.branch}
              productID={record.id}
              product={record}
              displayType={2}
            />
          );
        },
      },
    ];
    if (user.role == "oic" || user.role == "warehouse") {
      newcols = newcols.concat(quickstatscol);
    }

    locations.map((loc) => {
      var newCol = {
        title:
          user.role == "admin" || user.role == "manager"
            ? loc.name
            : "Quantity",
        dataIndex: `${loc.id}_count`,
        key: `${loc.id}_count`,
        className: "whitebg",
        render: (text, record, index) => {
          var currentCount = parseFloat(text);
          var status = null;
          var restock_count = 0;
          if (record[`${loc.id}_restock`]) {
            restock_count = parseFloat(record[`${loc.id}_restock`]);
            if (restock_count > 0) {
              if (currentCount < restock_count * 1.25) {
                status = "NEAR";
              }
              if (currentCount <= restock_count) {
                status = "RESTOCK";
              }
            }
          }

          if (text || text == 0) {
            return (
              <div
                className={
                  status == "RESTOCK"
                    ? `restock`
                    : status == "NEAR"
                    ? "near"
                    : " "
                }
              >
                <Tooltip
                  title={
                    <div className="vertical">
                      <div>{`${numberWithCommas(parseFloat(text).toFixed(2))} ${
                        record.unit
                      }`}</div>
                      {record.second_unit_rate ? (
                        <div>{`${numberWithCommas(
                          (
                            parseFloat(text) *
                            parseFloat(record.second_unit_rate)
                          ).toFixed(2)
                        )} ${record.second_unit}`}</div>
                      ) : null}
                    </div>
                  }
                >
                  <ProductLogModal
                    display={numberWithCommas(parseFloat(text).toFixed(2))}
                    branch={loc}
                    thisItem={record}
                  />
                </Tooltip>
              </div>
            );
          } else {
            return 0;
          }
        },
      };
      if (
        user.role == "admin" ||
        user.role == "manager" ||
        loc.id == userlocation
      ) {
        newcols = newcols.concat(newCol);
      }
    });

    var totalandincomingcols = [
      {
        title: "Incoming",
        dataIndex: `incoming_count`,
        key: `incoming_count`,
        className: "whitebg",
        render: (text, record, index) => {
          if (
            user.role == "admin" ||
            user.role == "warehouse" ||
            user.role == "manager"
          ) {
            return (
              <div
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
                style={{ height: "100%" }}
              >
                <InputNumber
                  min={0}
                  value={record.incoming_count ? record.incoming_count : 0}
                  defaultValue={
                    record.incoming_count ? record.incoming_count : 0
                  }
                  onChange={(e) => {
                    changeIncomingCount(record, index, e);
                  }}
                />
                {record.incoming_count &&
                record.incoming_count > 0 &&
                user.role !== "oic" ? (
                  <Popconfirm
                    title="Receive Incoming Count?"
                    onConfirm={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      acceptIncoming(record);
                    }}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button type="primary" size={"small"} loading={loading}>
                      Receive
                    </Button>
                  </Popconfirm>
                ) : null}
              </div>
            );
          } else {
            return (
              <div
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
                className="govertical"
              >
                <span style={{ width: "100%" }}>{text}</span>
                {record.incoming_count &&
                record.incoming_count > 0 &&
                user.role !== "oic" ? (
                  <Popconfirm
                    title="Receive Incoming Count?"
                    onConfirm={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      acceptIncoming(record);
                    }}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button type="primary" size={"small"} loading={loading}>
                      Receive
                    </Button>
                  </Popconfirm>
                ) : null}
              </div>
            );
          }
        },
      },
      {
        title: "Total",
        className: "whitebg",
        render: (text, record, index) => {
          var total = 0;
          var current = record[`${user.branch}_count`];
          if (current) {
            total = total + parseFloat(current);
          }
          if (record.incoming_count) {
            total = total + parseFloat(record.incoming_count);
          }
          return numberWithCommas(total.toFixed(2));
        },
      },
    ];

    if (
      user.role == "admin" ||
      user.role == "warehouse" ||
      user.role == "manager"
    ) {
      newcols = newcols.concat(totalandincomingcols);
    }

    var restockColumn = [
      {
        title: "Restock",
        dataIndex: "restock_status",
        key: "restock_status",
        className: "whitebg",
        filters: [
          {
            text: "RESTOCK",
            value: "RESTOCK",
          },
          {
            text: "NEAR",
            value: "NEAR",
          },
          {
            text: "GOOD",
            value: "GOOD",
          },
          {
            text: "N/A",
            value: "X",
          },
        ],
        onFilter: (value, record) => value.includes(record.restock_status),
        sorter: {
          compare: (a, b) => a.restock_status.localeCompare(b.restock_status),
          multiple: 5,
        },
        render: (text, record, index) => {
          if (text == "RESTOCK") {
            return <Tag color="red">RESTOCK</Tag>;
          } else if (text == "NEAR") {
            return <Tag color="yellow">NEAR</Tag>;
          } else if (text == "GOOD") {
            return <Tag color="green">GOOD</Tag>;
          } else {
            return <Tag color="#d4d1cb">N/A</Tag>;
          }
        },
      },
    ];
    newcols = newcols.concat(restockColumn);

    var addcart = {
      title: "",
      width: "5em",
      fixed: "right",
      render: (text, record, index) => {
        var not_available = true;
        if (record.regionalization == "international") {
          if (hqloc) {
            if (record[`${hqloc}_count`]) {
              if (parseFloat(record[`${hqloc}_count`]) > 0) {
                not_available = false;
              }
            }
          }
        } else {
          not_available = false;
        }
        if (user.role == "warehouse" || user.role == "manager") {
          not_available = false;
        }

        return (
          <div
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <PackageAddtoCartButton
              record={record}
              not_available={not_available}
              loading={loading}
              cartAdd={(rec, qty) => {
                cartAdd(rec, qty);
              }}
            />

            {not_available ? (
              <span className="outofstock">*out of stock</span>
            ) : null}
            {record.need_scan && user.role !== "oic" ? (
              <PrintProductBarCode currentItem={record} />
            ) : null}
          </div>
        );
      },
    };
    var warehouseactions = {
      title: "",
      width: "5em",
      fixed: "right",
      render: (text, record, index) => {
        return (
          <div>
            {record.need_scan && user.role !== "oic" ? (
              <PrintProductBarCode currentItem={record} />
            ) : null}
          </div>
        );
      },
    };
    // if(user.role == 'warehouse'){
    // newcols = newcols.concat(warehouseactions)
    // }
    // if(user.role !== 'warehouse'){
    newcols = newcols.concat(addcart);
    // }
    if (user.role == "oic") {
      newcols = newcols.filter((rw) => rw.title !== "Price");
    }

    return newcols;
  };

  const menuItemfiltering = () => {
    console.log(user);
    if (
      user.role == "admin" ||
      user.role == "manager" ||
      user.role == "warehouse" ||
      (user.branch == "EbJPvhCb11UaKbutec49" && user.role == "oic")
    ) {
      return (
        <div className="menuswitch">
          <Switch
            checkedChildren="Menu Items"
            unCheckedChildren="Menu Items"
            onChange={(e) => {
              setMenuItemsOnly(e);
            }}
          />
        </div>
      );
    }
  };

  return (
    <div className="maindiv">
      <div className={"generic_container"}>
        <PageHeader
          title={PAGENAME + "s"}
          subTitle={
            <div className={"header"}>
              {menuItemfiltering()}

              {/* <Search placeholder="input search text" allowClear={true} onChange={(e)=>{if(!e.target.value &&mainSearch){onSearch(null)}}} onSearch={onSearch} enterButton />  */}
            </div>
          }
          extra={
            <div className={"header"}>
              {menuItemsOnly ? (
                <RecalculateProductPrice
                  onModalClose={(action) => {
                    if (action == "reset") {
                      setResetTable(!resetTable);
                    }
                  }}
                  categoryFilters={categoryFilters}
                />
              ) : null}

              <ProductsAddEditModal
                headername={PAGENAME}
                currentItem={currentSelected}
                modalMode={modalMode}
                blueprint={
                  user.role == "admin"
                    ? ADMIN_MODAL_BLUEPRINT
                    : user.role == "warehouse" || user.role == "manager"
                    ? menuItemsOnly
                      ? MODAL_BLUEPRINT
                      : WAREHOUSE_MODAL_BLUEPRINT
                    : MODAL_BLUEPRINT
                }
                apiurl={API_URL}
                internationalblueprint={INTERNATIONAL_MODAL_BLUEPRINT}
                onModalClose={(action) => {
                  setModalMode("add");
                  setCurrentSelected(null);
                  if (action == "reset") {
                    setResetTable(!resetTable);
                  }
                }}
              />

              {crudDataCount > 0 ? (
                <Button
                  type={"primary"}
                  shape={"round"}
                  onClick={() => {
                    dispatch(loadMoreProductData());
                  }}
                  style={{ marginRight: "1em" }}
                >
                  Load More
                </Button>
              ) : null}

              <Button
                onClick={() => {
                  setResetTable(!resetTable);
                }}
                className="button"
              >
                <ReloadOutlined />
              </Button>
            </div>
          }
        ></PageHeader>
        <div className={"content_container"}>
          <ProductsTable
            ref={tableRef}
            apiurl={API_URL}
            columns={menuItemsOnly ? menuItemsColumns() : filterColumns()}
            mainSearch={mainSearch}
            resetTable={resetTable}
            ChangedSelected={(selected) => {
              console.log(selected);
            }}
            menuItemsOnly={menuItemsOnly}
          />
          {/* <ProductCards 
                      ref={tableRef} 
                      apiurl={API_URL}
                      columns={filterColumns()}
                      mainSearch={mainSearch}
                      resetTable={resetTable}
                      ChangedSelected={(selected)=>{itemSelected(selected)}}
                    
                    /> */}
        </div>
      </div>
    </div>
  );
};

export default Index;
